module.exports = __webpack_public_path__ + "static/media/profile.8bbf1475.svg";